export function getQueryObjectFromApiUrl(apiUrl) {
  try {
    const url = new URL(apiUrl);
    return Object.fromEntries(url.searchParams.entries());
  } catch (e) {
    return {};
  }
}

export function buildUrlFromApiPagination(apiUrl, currentPathname) {
  if (!apiUrl) return currentPathname;

  const params = getQueryObjectFromApiUrl(apiUrl);
  const qs = new URLSearchParams(params).toString();

  return qs ? `${currentPathname}?${qs}` : currentPathname;
}
